<template>
  <BaseDialog :is-open="isOpen" @close="emit('close')">
    <div class="py-4">
      <h2 class="text-center text-lg font-semibold"
        >Unpair Terminal</h2
      >
      <h3
        class="mb-2 text-center text-xs text-background-fg/50"
        >serial: {{ props.terminalId }}
      </h3>
      <template v-if="isLoading">
        <div class="w-32">
          <BaseInnerLoading
            class="relative bg-transparent"
            spinner-class="size-8"
          />
          <p
            class="mb-3 text-center text-sm font-semibold text-background-fg/70"
          >
            Unpairing...
          </p>
        </div>
      </template>
      <template v-else>
        <p
          class="mb-3 text-sm font-semibold text-background-fg/70"
        >
          Are you sure you want to unpair this terminal?
        </p>
        <div class="text-center">
          <ButtonPrimary
            class="mt-2 self-end"
            @click="emit('close')"
            >Cancel</ButtonPrimary
          >
          <ButtonPrimary
            class="ml-1 mt-2 self-end"
            @click="unpair"
            >Unpair</ButtonPrimary
          >
        </div>
        <template v-if="!!errorText">
          <p class="mt-3 text-center text-xs text-error">{{
            errorText
          }}</p>
        </template>
      </template>
    </div>
  </BaseDialog>
</template>

<script setup lang="ts">
const props = defineProps<{
  isOpen: boolean
  terminalId: string
}>()

const emit = defineEmits<{
  (event: "close"): void
}>()

const isLoading = ref(false)
const errorText = ref("")

const unpair = async () => {
  try {
    errorText.value = ""
    isLoading.value = true
    await unpairTerminal({
      serialNumber: props.terminalId,
    })
    emit("close")
  } catch (error) {
    if (error instanceof ApiError && error.status === 404) {
      errorText.value = `Terminal with serial number: ${props.terminalId} could not be found`
    } else {
      errorText.value =
        "There was an error when trying to unpair. Please try again."
    }
  } finally {
    isLoading.value = false
  }
}
</script>
